import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Table,
  TableContainer,
  ModalBody,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useDisclosure,
  FormControl,
  Input,
  FormErrorMessage,
  InputRightElement,
  InputLeftElement,
  Center,
  InputGroup,
  HStack,
  useToast,
  Spinner,
  Select as ChakraSelect,
  Stack
} from "@chakra-ui/react";
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../context/AppContext";
import { Formik, Field } from "formik";
import { BiHide, BiShow, BiSearch } from "react-icons/bi";
import { GetAllUsers, SetBlock } from "../../../utils/api";
import UserCard from "../components/UserCard";
import Empty from "../../../components/Empty";
const Users = () => {
  const { AdminToken, signupUser } = useContext(AppContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [show, setShow] = React.useState(false);
  const [blockModal, setBlockModal] = React.useState(false);
  const [pass, setPass] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [limitNo, setLimitNo] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const toast = useToast();
  const [checkUser, setCheckUser] = useState({ isBlock: "", userId: "" });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState({});
  const [search, setSearch] = useState("");

  // Define the debounced function

  const handleSetBlock = () => {
    SetBlock({ userId: checkUser.userId, block: checkUser.isBlock }, AdminToken)
      .then((res) => {
        toast({
          title: `User successfully ${checkUser.isBlock ? "Unblocked" : "Blocked"
            }`,
          status: "warning",
          isClosable: true,
          duration: 1500,
        });
        if (searched.email) setSearched({ ...searched, isBlock: res.data.status });
        let currentData = data;
        currentData = currentData.map((el) => {
          if (el._id == checkUser.userId) {
            el.isBlock = res.data.status;
          }
          return el;
        });
        setData([...currentData]);
        CloseBlockModal();
      })
      .catch((err) => {
        CloseBlockModal();
        console.log(err);
      });
  };
  const OpenBlockModal = (userId, isBlock) => {
    setBlockModal(true);
    setCheckUser({ isBlock, userId });
  };
  const CloseBlockModal = () => {
    setBlockModal(false);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setLoading(false);
      GetAllUsers(AdminToken, pageNo, limitNo, search)
        .then((res) => {
          setLoading(true);
          setData(res.data.data);
          setTotalPages(res.data.pagination.totalPages);
        })
        .catch((err) => {
          setLoading(true);
          console.log(err, "error message");
        });
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [limitNo, pageNo, search]);

  return (
    <VStack
      gap={"1rem"}
      bg={"gray.900"}
      align={"end"}
      justify={"start"}
      height={"100%"}
      w={"100%"}
      p={{ base: "1rem", md: "1.5rem" }}
    >
      <Stack direction={{ base: "column", md: "row" }} w={"100%"} justify={"space-between"}>
        <InputGroup w={{ base: "100%", md: "30%" }}>
          <InputLeftElement pointerEvents="none">
            <BiSearch color="gray.300" />
          </InputLeftElement>
          <Input
            type="text"
            placeholder="Search by email..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPageNo(1);
            }}
            focusBorderColor="#319795"
            borderColor="gray.600"
            color="white"
            _hover={{ borderColor: "gray.500" }}
            _placeholder={{ color: "gray.400" }}
          />
        </InputGroup>
        <Button
          _hover={{
            bgColor: "gray.800",
            color: "#319795",
          }}
          onClick={onOpen}
          color={"white"}
          bgColor={"#319795"}
          border={"2.4px solid #319795 !important"}
        >
          Add User
        </Button>
      </Stack>
      {!loading && (
        <VStack justify={"center"} w={"100%"} minH={"50vh"}>
          <Spinner
            thickness="5px"
            speed="0.55s"
            emptyColor="gray.200"
            color="teal.400"
            size="xl"
          />
        </VStack>
      )}
      {totalPages > 1 && (
        <HStack gap={"1rem"} align={"center"} wrap="wrap" justify="center" w="full">
          <ChakraSelect
            onChange={(e) => {
              setLimitNo(Number(e.target.value));
              setPageNo(1);
            }}
            color="white"
            bg="gray.800"
            borderColor="gray.600"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={40}>40</option>
            <option value={60}>60</option>
            <option value={80}>80</option>
            <option value={100}>100</option>
          </ChakraSelect>
          <Button
            onClick={() => {
              setPageNo(1);
            }}
            padding={"0.5rem 1rem"}
            width={"fit-content"}
            color="white"
            _hover={{ bg: "gray.700" }}
          >
            First
          </Button>
          <Button
            onClick={() => {
              setPageNo((pre) => {
                if (pre > 1) {
                  return pre - 1;
                } else {
                  return pre;
                }
              });
            }}
            color="white"
            _hover={{ bg: "gray.700" }}
          >
            {"<<"}
          </Button>
          <Text
            padding={"0.5rem 1rem"}
            border={"1px solid gray"}
            borderRadius={"5px"}
            color="white"
          >
            {pageNo}
          </Text>
          <Text color="white">/</Text>
          <Text
            padding={"0.5rem 1rem"}
            border={"1px solid gray"}
            borderRadius={"5px"}
            color="white"
          >
            {totalPages}
          </Text>
          <Button
            onClick={() => {
              setPageNo((pre) => {
                if (pre < totalPages) {
                  return pre + 1;
                } else {
                  return pre;
                }
              });
            }}
            color="white"
            _hover={{ bg: "gray.700" }}
          >
            {">>"}
          </Button>
          <Button
            onClick={() => {
              setPageNo(totalPages);
            }}
            padding={"0.5rem 1rem"}
            width={"fit-content"}
            color="white"
            _hover={{ bg: "gray.700" }}
          >
            Last
          </Button>
        </HStack>
      )}
      {data.length && loading ? (
        <TableContainer
          boxShadow={"rgba(149, 157, 165, 0.2) 0px 8px 24px"}
          w={"100%"}
        >
          <Table
            variant="simple"
            colorScheme="facebook"
            bgColor="gray.800"
            size={["md", "lg", "lg"]}
            overflowX={"auto"}
            boxShadow={"rgba(149, 157, 165, 0.2) 0px 8px 24px"}
          >
            <Thead background={"#319795"} color={"white !important"}>
              <Tr>
                <Th color={"white"}>Name</Th>
                <Th color={"white"}>Email</Th>
                <Th color={"white"}>Balance</Th>
                <Th color={"white"}>Deposite</Th>
                <Th color={"white"}>Status</Th>
                <Th color={"white"}>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((el) => {
                return (
                  <UserCard
                    OpenBlockModal={OpenBlockModal}
                    CloseBlockModal={CloseBlockModal}
                    key={el._id}
                    id={el._id}
                    isBlock={el.isBlock}
                    totalWalletBalance={el.totalWalletBalance}
                    name={el.name || "user"}
                    email={el.email}
                    balance={el.balance || 0}
                  />
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <></>
      )}

      {!data.length && loading ? <Empty title={"No user found!!!"} /> : <></>}
      {/* Block User Modal  */}
      <Modal isOpen={blockModal} onClose={CloseBlockModal}>
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white">
          <ModalCloseButton />
          <ModalBody
            display={"flex"}
            justifyContent={"center"}
            minH={"30vh"}
            flexDirection={"column"}
            gap={"1rem"}
            alignItems={"center"}
            pb={6}
          >
            <Text fontSize={"1.4rem"} fontWeight={"600"}>
              Are you sure to {!checkUser.isBlock ? "block" : "unblock"} user!!!
            </Text>
            <HStack>
              <Button
                onClick={() => {
                  handleSetBlock();
                }}
                _hover={{
                  bgColor: "gray.700",
                  color: "#319795",
                }}
                color={"white"}
                bgColor={"#319795"}
                border={"2.4px solid #319795 !important"}
              >
                Confirm
              </Button>
              <Button
                color={"#319795"}
                bg={"gray.800"}
                border={"2.4px solid #319795 !important"}
                _hover={{
                  bgColor: "#319795",
                  color: "white",
                }}
                onClick={CloseBlockModal}
              >
                Cancel
              </Button>
            </HStack>
          </ModalBody>
        </ModalContent>
      </Modal>
      {/* Add User Modal  */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="gray.800" color="white">
          <ModalCloseButton />
          <ModalBody
            display={"flex"}
            justifyContent={"center"}
            minH={"30vh"}
            gap={"1rem"}
            alignItems={"center"}
            pb={6}
            pt={5}
          >
            <Formik
              initialValues={{
                email: "",
                password: "",
              }}
              onSubmit={(values) => {
                signupUser(values.email, values.password)
                  .then((res) => {
                    onClose();
                    console.log(res, "inside users.jsx");
                    GetAllUsers(AdminToken)
                      .then((newres) => {
                        setData(newres.data.users);
                      })
                      .catch((err) => {
                        console.log(err, "error message");
                      });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
            >
              {({ handleSubmit, errors, touched }) => (
                <form style={{ width: "76.5%" }} onSubmit={handleSubmit}>
                  <VStack p={"1.5rem 0.8rem"} align="flex-start">
                    <FormControl
                      position={"relative"}
                      isInvalid={!!errors.email && touched.email}
                    >
                      <Field
                        as={Input}
                        id="email"
                        name="email"
                        placeholder={"Email"}
                        type="email"
                        variant="outline"
                        border="2px solid"
                        borderColor="gray.600"
                        color="white"
                        _hover={{ background: "gray.700", color: "white" }}
                        validate={(value) => {
                          let error;
                          if (!value) {
                            error = "Required";
                          } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                              value
                            )
                          ) {
                            error = "Invalid email address";
                          }
                          return error;
                        }}
                      />
                      <FormErrorMessage
                        bottom={"-20.5px"}
                        position={"absolute"}
                      >
                        {errors.email}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      marginTop={"1.5rem !important"}
                      isInvalid={!!errors.password && touched.password}
                    >
                      <InputGroup position={"relative"}>
                        <Field
                          as={Input}
                          id="password"
                          placeholder={"Password"}
                          name="password"
                          type={show ? "text" : "password"}
                          border="2px solid"
                          borderColor="gray.600"
                          _hover={{ background: "gray.700", color: "white" }}
                          validate={(value) => {
                            let error;
                            if (!value) {
                              error = "Required ";
                            } else if (value.length < 7) {
                              error =
                                "Password must contain at least 8 characters";
                            }
                            setPass(value);
                            return error;
                          }}
                        />
                        <InputRightElement width="3rem">
                          <Center
                            fontSize="25px"
                            bg="none"
                            cursor={"pointer"}
                            onClick={() => setShow(!show)}
                          >
                            {show ? (
                              <BiHide style={{ cursor: "pointer" }} />
                            ) : (
                              <BiShow style={{ cursor: "pointer" }} />
                            )}
                          </Center>
                        </InputRightElement>
                      </InputGroup>
                      <FormErrorMessage
                        bottom={"-20.5px"}
                        position={"absolute"}
                      >
                        {errors.password}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      marginTop={"1.5rem !important"}
                      isInvalid={!!errors.confirm && touched.confirm}
                    >
                      <InputGroup position={"relative"}>
                        <Field
                          as={Input}
                          id="confirm"
                          name="confirm"
                          placeholder={"Confirm Password"}
                          type={show ? "text" : "password"}
                          border="2px solid"
                          borderColor="gray.600"
                          color="white"
                          _hover={{ background: "gray.700", color: "white" }}
                          validate={(value) => {
                            let error;
                            if (!value) {
                              error = "Required ";
                            } else if (value.length > 5 && pass !== value) {
                              error = "Password must be same";
                            }
                            return error;
                          }}
                        />
                        <InputRightElement width="3rem">
                          <Center
                            fontSize="25px"
                            bg="none"
                            cursor={"pointer"}
                            onClick={() => setShow(!show)}
                          >
                            {show ? (
                              <BiHide style={{ cursor: "pointer" }} />
                            ) : (
                              <BiShow style={{ cursor: "pointer" }} />
                            )}
                          </Center>
                        </InputRightElement>
                      </InputGroup>
                      <FormErrorMessage
                        bottom={"-20.5px"}
                        position={"absolute"}
                      >
                        {errors.confirm}
                      </FormErrorMessage>
                    </FormControl>
                    <Button
                      _hover={{
                        color: "#319795",
                        background: "gray.800",
                      }}
                      type="submit"
                      mt={"2rem !important"}
                      bg="#319795"
                      color={"white"}
                      border="1.5px solid #319795 !important"
                      width="full"
                      outline={"none"}
                    >
                      Create new user
                    </Button>
                  </VStack>
                </form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </VStack>
  );
};

export default Users;
